import Box from '@mui/material/Box';
import { MONO_FONT } from '@/theme';

/**
 * Etiqueta de sección: línea dorada + texto en mayúsculas espaciadas.
 *
 * @param {'dark'|'light'} tone  dark → sobre navy (dorado claro) · light → sobre crema (dorado oscuro)
 * @param {boolean} center       centra la etiqueta con línea a ambos lados
 * @param {'section'|'hero'} variant  hero = línea de 46px, tracking 0.34em, weight 600 (prototipo)
 */
export default function Eyebrow({
  children,
  tone = 'dark',
  center = false,
  variant = 'section',
  sx = {},
}) {
  const color = tone === 'dark' ? 'primary.main' : 'primary.dark';
  const isHero = variant === 'hero';
  const rule = {
    content: '""',
    width: isHero ? 46 : 36,
    height: '1px',
    bgcolor: 'currentColor',
    flexShrink: 0,
  };

  return (
    <Box
      component="span"
      sx={{
        fontFamily: MONO_FONT,
        fontSize: '11px',
        fontWeight: isHero ? 600 : 700,
        letterSpacing: isHero ? '0.34em' : '0.3em',
        textTransform: 'uppercase',
        color,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '14px',
        '&::before': rule,
        ...(center && { '&::after': rule }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
